import Grid2 from '@mui/material/Unstable_Grid2';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import { useTranslation } from 'react-i18next';
import { type IntegrationParamOption } from 'src/shared/api/integrations/common';
import { Step } from '../../components/Step';
import { SelectCheckbox } from '../../components/SelectCheckbox';
import { mapParamOptionsToSelect } from '../utils';

type Step3Props = {
  absenceTypes: IntegrationParamOption[];
};

export const Step3 = ({ absenceTypes }: Step3Props) => {
  const { t } = useTranslation('settings');
  const mappedData = mapParamOptionsToSelect(absenceTypes);

  return (
    <Step
      title={`${t('integrations.step')} 3`}
      subtitle={t('integrations.bizneo.select the absence types you want to synchronize')}
      Icon={WorkOffIcon}
    >
      <Grid2 xs={12}>
        <SelectCheckbox data={mappedData} name="includeAbsenceTypes" />
      </Grid2>
    </Step>
  );
};
